import * as React from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../AppModulesWrapper';

import { selectIsSubagentLimitExceed } from '../../selectors/publishTerms';
import { selectIsMobileLayout } from '../../selectors/layout';

import { ActionButtons } from './ActionButtons';

export const ActionButtonsContainer = () => {
  const { isMicrofrontend } = useAppContext();

  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);
  const isMobile = useSelector(selectIsMobileLayout);
  const withPublishBtn = !isMobile || !isSubagentLimitExceed;

  return isMicrofrontend ? null : <ActionButtons withPublishBtn={withPublishBtn} />;
};
